import React, { useEffect } from 'react';
import { Scrollbars } from "react-custom-scrollbars-2";
import styles from './Sidebar.module.scss';

function BaseSidebar ({ 
    isOpen, 
    onClose, 
    width, 
    onResizeStart, 
    children, 
    footerActions,
    style = {},
    showScrollbar = true,
    className = "",
    top // Optional offset from the top of the viewport in px, defaults to the header height in the stylesheet
}) {
    const topStyle = top === undefined ? {} : { top, height: `calc(100vh - ${top}px)` };

    // Handle Escape Key
    useEffect(() => {
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape' && isOpen) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscapeKey);
        }
        return () => document.removeEventListener('keydown', handleEscapeKey);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

return (
        <>
            <div 
                className={styles['drag-handle']} 
                style={{ right: width, ...topStyle }} 
                onMouseDown={onResizeStart}
            />
            
            <div className={styles['base-sidebar']} style={{ width, ...topStyle }}>
                {/* 1. Scrollable Body */}
                <div className={styles['sidebar-body']}>
                    <Scrollbars autoHide>
                        <div className={styles['content-padding']}>
                            {children}
                        </div>
                    </Scrollbars>
                </div>
                
                {/* 2. Static Footer */}
                {footerActions && (
                    <div className={styles['sidebar-footer']}>
                        {footerActions}
                    </div>
                )}
            </div>
        </>
    );
};

export default BaseSidebar;